import React from 'react';
import { PickerContainer, Label, Input } from './styled';
import { PlusIcon } from '@unfold/icon';

interface IAvatarPickerProps {
  onUpload: (file: File) => void;
}

const AvatarPicker: React.FC<IAvatarPickerProps> = (props) => {
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (!e.target.files) {
      return;
    }

    props.onUpload(e.target.files[0]);
  };

  return (
    <PickerContainer>
      <Label htmlFor="avatar"><PlusIcon /></Label>
      <Input type="file" id="avatar" onChange={handleUpload} />
    </PickerContainer>
  );
};

export default AvatarPicker;
